module.exports = __webpack_public_path__ + "static/media/CA.0801c62b.svg";